<template>
  <Paginate
    container-class="pagination"
    prev-class="pagination-page"
    page-class="pagination-page"
    next-class="pagination-page"
    prev-link-class="pagination-link"
    page-link-class="pagination-link"
    next-link-class="pagination-link"
    :force-page="page"
    :page-count="pageCount"
    :click-handler="onClick">
    <template v-slot:prevContent>
      <span class="arrow arrow-l arrow-primary"></span>
    </template>
    <span
      slot="nextContent"
      class="arrow arrow-r arrow-primary"/>
  </Paginate>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
  },
  methods: {
    onClick(page) {
      this.$emit('change', page);
    },
  },
};
</script>
